"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../../theming/make-styles.js";
const useStyles = makeStyles()({
    footer: {
        backgroundColor: "inherit",
    },
});
export const DialogFooter = React.forwardRef(function DialogFooter(_a, ref) {
    var { className } = _a, props = __rest(_a, ["className"]);
    const { classes, cx } = useStyles();
    return _jsx("div", Object.assign({ ref: ref, className: cx(classes.footer, className) }, props));
});
export default DialogFooter;
//# sourceMappingURL=dialog-footer.js.map